import React from 'react';

const NavProfile = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.3033 4.6967C18.2322 7.62563 18.2322 12.3744 15.3033 15.3033C12.3743 18.2322 7.62562 18.2322 4.6967 15.3033C1.76777 12.3743 1.76777 7.62562 4.6967 4.6967C7.62563 1.76777 12.3744 1.76777 15.3033 4.6967"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6575 6.93659C12.5729 7.85204 12.5729 9.33629 11.6575 10.2517C10.742 11.1672 9.2578 11.1672 8.34235 10.2517C7.4269 9.33629 7.4269 7.85204 8.34235 6.93659C9.2578 6.02114 10.742 6.02114 11.6575 6.93659"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.7558 15.7983C13.56 14.5392 11.8733 13.75 9.99997 13.75C8.12664 13.75 6.43997 14.5392 5.24414 15.7992"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NavProfile;
